import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

import {useRouter, useRoute} from "vue-router";
  import {ref,provide,nextTick} from 'vue'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  let route = useRoute();
  let router = useRouter();

  //操作数据后 页面实时更新
  let isShow = ref(true);
  provide('refresh', {
    reload: () => {
      isShow.value = false;
      nextTick(() => {
        isShow.value = true;
      })
    }
  });

  // const e = window.e;
  // window.onerror = function (errorMessage, scriptURI, lineNumber, columnNumber, error) {
  //   if(errorMessage === 'ResizeObserver loop limit exceeded') {
  //     console.warn(errorMessage);
  //     return true
  //   }else {
  //     return e(...arguments)
  //   }
  // }


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(isShow))
    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }, {
        default: _withCtx(({Component}) => [
          _createVNode(_Transition, null, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_KeepAlive, { include: "AheadAdmit,MobileFirstPage,MobileMajorSearch" }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})